import ScreenReviewList from 'screens/Review/List';
import ScreenReviewDetails from 'screens/Review/Details';
import { REVIEWS } from 'routes/paths';

const reviewRoutes = [
  {
    path: REVIEWS.LIST,
    name: 'reviews_list',
    component: ScreenReviewList,
    loginRequired: true,
    allowPermissions: ['list_review'],
  },
  {
    path: REVIEWS.DETAILS,
    name: 'reviews_details',
    component: ScreenReviewDetails,
    loginRequired: true,
    allowPermissions: ['view_review'],
  },
];

export default reviewRoutes;
